import { createFileRoute } from '@tanstack/react-router';
import { LayoutEditRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/layouts/$layoutId/edit')({
  component: LayoutEditRoute,
});
